import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class FeatureTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "ledColumn", title: "Mode" },
        { name: "blueColumn", title: "Blue LED" },
        { name: "redColumn", title: "Red LED" },
      ],
      rows: [
        { ledColumn: 'Konstant AN', blueColumn: 'Mit WLAN Verbunden', redColumn: 'Mit WLAN Verbunden' },
        { ledColumn: 'Lansam Blinken', blueColumn: 'WPS Aktiv', redColumn: 'WPS Aktiv' },
        { ledColumn: 'Schnell Blinken', blueColumn: 'N/A', redColumn: 'N/A' },
        { ledColumn: 'Aus', blueColumn: 'LED deaktiviert oder kein Strom', redColumn: 'LED deaktiviert oder kein Strom' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

FeatureTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(FeatureTable)